import type { OnboardingData } from "./types";

/** Persisted invite context never activates partner mode after a reload. */
export function sanitizeHydratedOnboardingData(
  stored: OnboardingData,
): OnboardingData {
  return { ...stored, partnerInvite: null };
}
